export const CELESTE = {
  accent: "#0891b2",
  accentDark: "#0ea5e9",
  accentLight: "#38bdf8",
  bg: "#ecfeff",
  bgHover: "#cffafe",
  bgSoft: "#f0fdff",
  border: "rgba(56, 189, 248, 0.28)",
  borderSoft: "#a5f3fc",
  borderSubmenu: "#bae6fd",
  shadow: "rgba(14, 165, 233, 0.28)",
};
